angular.module('services').service('Google', ($q, $window) => {

    /**
        A deferred object for keeping the status of loading the FB SDK
        @type {$q.defer}
    */
    let deferred = $q.defer();
    /**
        The script tag HTML id for the Google JS SDK
        @type String
    */
    const SCRIPT_ID = 'google-jssdk';

    /**
        The Google Client API id
        $type String
    */

    const CLIENT_ID = '719247549433-t3io58co4udt58deh995uiet3p2rpikk.apps.googleusercontent.com';

    let SCOPES = 'https://www.googleapis.com/auth/plus.login';
    SCOPES += ' https://www.googleapis.com/auth/userinfo.email';
    SCOPES += ' https://www.googleapis.com/auth/userinfo.profile';

    /**
         Initializes the GOOGLE JS SDK.
    */
    function initAPI() {

        deferred.resolve();

    }

    /**
        Initializer for the Sandbox extension.
        Loads the Facebook JS SDK and sets up its initialization.
    */
    function init() {

        if (!$window || !$window.document) {

            deferred.reject();
            return;

        }

        if ($window.document.getElementById(SCRIPT_ID)) {

            deferred.resolve();
            return;

        }

        window.___gcfg = {
            lang: CWCONFIG.language ? CWCONFIG.language : 'en',
        };

        const gplusScript = $window.document.createElement('script');
        gplusScript.type = 'text/javascript';
        gplusScript.async = true;
        gplusScript.id = SCRIPT_ID;
        gplusScript.src = 'https://apis.google.com/js/client:plusone.js?onload=gplusAsyncInit';

        const jsScripts = $window.document.getElementsByTagName('script')[0];
        jsScripts.parentNode.insertBefore(gplusScript, jsScripts);

        $window.gplusAsyncInit = initAPI;

    }

    /**
        Callback for login API event
    */
    function handleAuthResult(authResult) {

        if (authResult && !authResult.error) {

            deferred.resolve(authResult);

        } else {

            deferred.reject();

        }

    }

    function login() {

        $window.gapi.auth.authorize({
            client_id: CLIENT_ID,
            scope: SCOPES,
            immediate: false,
        }, handleAuthResult);

        deferred = $q.defer();
        return deferred.promise;

    }

    /**
        Makes API call to get user info
    */

    function getUserInfo(callback) {

        $window.gapi.client.load('plus', 'v1', () => {

            const request = $window.gapi.client.plus.people.get({
                userId: 'me',
            });
            request.execute((resp) => {

                callback(resp);

            });

        });

    }

    /**
        Returns a promise that will be resolved when the G+ SDK is loaded
        @returns {jQuery.Promise}
    */
    function loaded() {

        return deferred.promise;

    }


    const exports = {
        init,
        loaded,
        login,
        getUserInfo,
    };

    return exports;

});



// WEBPACK FOOTER //
// ./scripts/services/google.js